import { render, staticRenderFns } from "./Chengyuanliebiao.vue?vue&type=template&id=62bf9104&"
import script from "./Chengyuanliebiao.vue?vue&type=script&lang=js&"
export * from "./Chengyuanliebiao.vue?vue&type=script&lang=js&"
import style0 from "./Chengyuanliebiao.vue?vue&type=style&index=0&id=62bf9104&prod&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports